module.exports = __webpack_public_path__ + "static/img/loss_of_income.578f1353.png";